import styled from 'styled-components';
import { useApiMutation } from '../../scripts/api/api_v2';
import { useRef, useState } from 'react';
import { Text } from '../../components/shared/Text';
import { PageEmpty } from '../../components/root/Page';
import { useNavigate } from 'react-router';
import { ButtonWhite } from '../../components/shared/Buttons';
import { Input } from '../../components/shared/Input';

const StyledLoginPage = styled.div`
	display: flex;
`;

const StyledLoginContainer = styled.div`
	margin: auto;
`;

const StyledLoginCard = styled.div``;

// TODO: Create route which redirects to login without cookie
// TODO: if cookie exists on login page > auto redirect to cards
// TODO: Store cookie somewhere in browser (cookie store?)
// TODO: Combine cookie to api for requests
// TODO: Create login API
export function LoginpPage() {
	const { fetchData: loginUser, loadingData, errorData } = useApiMutation('auth.login');

	const navigate = useNavigate();

	const loggingInRef = useRef<boolean>(false);
	const [keyInput, setKeyInput] = useState<string>('');
	const [passwordInput, setPasswordInput] = useState<string>('');

	const onClickLogin = async () => {
		if (loggingInRef.current) return;
		loggingInRef.current = true;
		try {
			const res = await loginUser({ body: { key: keyInput, password: passwordInput } });
			if (res?.code === 200) {
				navigate('/orders');
			} else {
				loggingInRef.current = false;
			}
		} catch (err) {
			console.error(err);
			loggingInRef.current = false;
		}
	};

	return (
		<PageEmpty>
			<StyledLoginPage>
				<StyledLoginContainer>
					<Text $color="text_title_main" $size="2.4rem" $weight="600">
						Xip Tix B.V.
					</Text>
					<StyledLoginCard>
						<Input
							placeholder="Key"
							value={keyInput}
							onChangeMap={(v) => v.trim()}
							onChange={setKeyInput}
						/>
						<Input
							placeholder="Password"
							type="password"
							value={passwordInput}
							onChangeMap={(v) => v.trim()}
							onChange={setPasswordInput}
						/>
						<ButtonWhite onClick={onClickLogin} disabled={loadingData}>
							Login
						</ButtonWhite>
						{errorData && (
							<Text $color="text_red" $size="1.4rem" $weight="400">
								{errorData}
							</Text>
						)}
					</StyledLoginCard>
				</StyledLoginContainer>
			</StyledLoginPage>
		</PageEmpty>
	);
}
